
<script>
export default {
  data: () => ({
    isLoading: false,
    dataTable: [],
    pageTitle: "專案",
    itemPerPage: 10, // -1 is all, default is 10, 5 is fine.
    search: "",
    searchTimer: null,
    delaySearch: "",
  }),
  methods: {
    onDelaySearchInput() {
      if (this.searchTimer !== null) window.clearTimeout(this.searchTimer)
      this.searchTimer = window.setTimeout(() => {
        this.searchTimer = null
        this.search = this.delaySearch
      }, 500)
    },
  }
}
</script>